import React, { ButtonHTMLAttributes, KeyboardEvent, MouseEvent } from "react";

// import { cx } from "@/ui/helpers";
import { cx } from "../../../helpers";

 import styles from "./styles.module.scss";
//  import globalStyles from "@/ui/styles/globals.module.css";

 import globalStyles from '../styles/globals.module.css'


type OwnProps = {
  className?: string;
  disabled?: boolean;
  onClick?: (event: MouseEvent | KeyboardEvent) => void;
  style?: React.CSSProperties;
};
export type CloseButtonProps = OwnProps &
  ButtonHTMLAttributes<HTMLButtonElement>;

export const CloseButton: React.FC<CloseButtonProps> = props => {
  const { className, disabled, onClick, style, ...rest } = props;

  return (
    <button
      className={cx(
        globalStyles.buttonReset,
        styles.close,
        className,
        disabled
         && globalStyles.disabled,
      )}
      disabled={disabled}
      onClick={onClick}
      style={style}
      {...rest}
      aria-label="close-button"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="-1 -1 26 26"
        strokeWidth="1.5"
        stroke="currentColor"
        className="h-full w-full"
        style={style}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  );
};
